import { render, staticRenderFns } from "./RecommendationParameterInterface.vue?vue&type=template&id=0a47fbea&"
import script from "./RecommendationParameterInterface.vue?vue&type=script&lang=js&"
export * from "./RecommendationParameterInterface.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationParameterInterface.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})
